

import axios from "axios";
import { CONFIG } from "../config";
import { getSubdirectory } from "./GetSubdirectory";

const baseUrl = CONFIG.baseURL || "/api";
const subdirectory = getSubdirectory();

const getAuthToken = () => {
    try {
        return localStorage.getItem(`${subdirectory}-token`);

    } catch (err) {
        console.warn("Invalid userProfile JSON in localStorage:", err);
        return "";
    }
};

const getRequest = async (path, params) => {

    try {
        const uri = baseUrl + path;
        let axiosParams = {
            method: "get",
            url: uri,
            params: params,
            headers: {
                "sesskey": sessionStorage.getItem("sessionID") ?? "",
                "Authorization": `Bearer ${getAuthToken()}`,
            },
        }
        let res = await axios(axiosParams);
        return res;
    } catch (error) {

        throw error
    }

}

const postRequest = async (path, params) => {

    try {
        const uri = baseUrl + path;

        let axiosParams = {
            method: "post",
            url: uri,
            data: params,
            headers: {
                "sesskey": sessionStorage.getItem("sessionID") || "",
                'Content-Type': params instanceof FormData ? 'multipart/form-data' : 'application/json',
                "Authorization": `Bearer ${getAuthToken()}`,
            }
        }
        let res = await axios(axiosParams);
        return res;
    } catch (error) {

        throw error
    }

}

export { getRequest, postRequest }

